import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  IconButton
} from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';

import { usePreviewStyles, useAttachmentStyles } from '../styles';

const Attachments = ({ attachments, removeAttachment }) => {
  const classes = usePreviewStyles();
  const attachmentClasses = useAttachmentStyles();

  const renderAttachment = (attachment, index) => {
    return (
      <Paper elevation={2} className={attachmentClasses.wrapper} key={index}>
        <img src={attachment} alt={`Brand Attachment ${index + 1}`} />
        <IconButton
          size="small"
          className={attachmentClasses.delete}
          onClick={() => removeAttachment(index)}
        >
          <DeleteIcon />
        </IconButton>
      </Paper>
    );
  };

  if (attachments.length > 0) {
    return (
      <div className={classes.wrapper}>
        {attachments.map(renderAttachment)}
      </div>
    );
  }

  return <p>No attachment available.</p>;
};

Attachments.propTypes = {
  attachments: PropTypes.arrayOf(String).isRequired,
  removeAttachment: PropTypes.func.isRequired,
};

export default Attachments;
